var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"delete-loan-text"},[_vm._v("Are you sure you want to delete this loan?")]),_c('OverviewModalFooter',{attrs:{"success":_vm.success,"waiting":_vm.waiting,"isDeleteModal":true,"primaryButtonName":"Delete"},on:{"handleClick":_vm.handleDeleteLoan,"close":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }